import {
  DynamicZoneComponentDTO,
  StrapiDynamicZoneComponentDTO,
} from "@lib/strapi/dtos/core/dynamicZoneComponent.dto";
import { parseStrapiContent } from "@lib/strapi/content";
import { MDXRemoteSerializeResult } from "next-mdx-remote";

export interface StrapiAppointmentCtaSectionDTO
  extends StrapiDynamicZoneComponentDTO {
  heading: string;
  prompt: string;
  style: "Phone" | "Form" | "Both";
  appearance?: "Bright" | "Dark";
}

export class AppointmentCtaSectionDTO extends DynamicZoneComponentDTO {
  constructor() {
    super();
  }

  heading: string;
  prompt: MDXRemoteSerializeResult;
  style: "Phone" | "Form" | "Both";
  /** editor-chosen (never auto-detected); absent ⇒ Bright */
  appearance?: "Bright" | "Dark";
}
